<script setup lang="ts">
import { useRouter, useRoute } from 'vue-router'

const router = useRouter()
const route = useRoute()

const navItems = [
  { title: 'Dashboard', path: '/' },
  { title: 'Crypto', path: '/crypto' },
  { title: 'หุ้นไทย', path: '/thai-stocks' },
]

function go(path: string) {
  if (route.path !== path) {
    router.push(path)
  }
}
</script>

<template>
  <v-app>
    <!-- App Bar -->
    <v-app-bar color="primary" flat  height="24">
      <v-app-bar-title>Millionaire Trader</v-app-bar-title>

      <v-spacer />

      <!-- Simple Navbar -->
      <v-btn
        v-for="item in navItems"
        :key="item.path"
        variant="text"
        @click="go(item.path)"
      >
        {{ item.title }}
      </v-btn>
    </v-app-bar>

    <!-- Main Content -->
    <v-main>
      <v-container>
        <RouterView />
      </v-container>
    </v-main>
  </v-app>
</template>
